import "../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/UpcomingEvents.style.css";
import React from "react";
import ScrollableShortCard from "../../../../Universal/ScrollableShortCard.component";
import UpcomingEventsCard from "../Activities/UpcomingEventsCard.component";
const UpcomingEvents = ({ eventsData }) => {
  return (
    <ScrollableShortCard title="Upcoming events">
      {eventsData &&
        eventsData.map((data, index) => (
          <UpcomingEventsCard
            key={index}
            eventName={data.eventName}
            eventDate={data.eventDate}
          />
        ))}
    </ScrollableShortCard>
  );
};

export default UpcomingEvents;
